import {
  NavigationActionTypes,
  NavigationState,
  SET_NAVIGATION_STATE,
} from "./types";

const DEFAULT_STATE: NavigationState = {
  title: null,
  left: null,
  right: null,
  bottom: null,
  themed: false,
  expanded: false,
  border: true,
  hidden: false,
};

export { DEFAULT_STATE };

export default (
  state = DEFAULT_STATE,
  action: NavigationActionTypes
): NavigationState => {
  switch (action.type) {
    case SET_NAVIGATION_STATE:
      return {
        ...state,
        ...action.state,
      };
    default:
      return state;
  }
};
